export const PROCESSING = 'PROCESSING';
export const PROCESSING_CSV = 'PROCESSING_CSV';
export const SET_LIST_ORDER = 'SET_LIST_ORDER';
export const GET_SINGLE_ORDER = 'GET_SINGLE_ORDER';
export const SET_ALL_LIST_ORDER = 'SET_ALL_LIST_ORDER';
export const GET_SINGLE_ORDER_SUCCESS = 'GET_SINGLE_ORDER_SUCCESS';
export const GET_SINGLE_ORDER_FAILED = 'GET_SINGLE_ORDER_FAILED';
export const GET_SINGLE_ORDER_STATUS = 'GET_SINGLE_ORDER_STATUS';
export const GET_SINGLE_ORDER_STATUS_SUCCESS =
  'GET_SINGLE_ORDER_STATUS_SUCCESS';
export const GET_SINGLE_ORDER_STATUS_FAILED = 'GET_SINGLE_ORDER_STATUS_FAILED';

export const SET_LIST_PARTNER = 'SET_LIST_PARTNER';
export const SET_PARTNER_DETAIL = 'SET_PARTNER_DETAIL';
export const UPDATE_PARTNER = 'UPDATE_PARTNER';
export const UPDATE_PARTNER_EDIT_STEP = 'UPDATE_PARTNER_EDIT_STEP';
export const INIT_PARTNER_EDIT = 'INIT_PARTNER_EDIT';

export const SET_LIST_CLIENT = 'SET_LIST_CLIENT';
export const SET_CLIENT_DETAILS = 'SET_CLIENT_DETAILS';
export const SET_GET_CLIENT_DETAILS_LOADING = 'SET_GET_CLIENT_DETAILS_LOADING';
export const SET_CREATE_NEW_CLIENT_LOADING = 'SET_CREATE_NEW_CLIENT_LOADING';
export const SET_REVOKE_CLIENT_LOADING = 'SET_REVOKE_CLIENT_LOADING';
export const SET_REFRESH_CLIENT_LOADING = 'SET_REFRESH_CLIENT_LOADING';
